// extracted by mini-css-extract-plugin
export const container = "contact-module--container--2igwq";
export const head = "contact-module--head--3bBnG";
export const headInfo = "contact-module--headInfo--14DvF";
export const bg = "contact-module--bg--2GwHn";
export const body = "contact-module--body--2z91p";
export const icon = "contact-module--icon--3uzrC";